import { SET_ADDFONT } from '../actions';

const fontadd = (state = [], action) => {
  switch (action.type) {
	case SET_ADDFONT:
      return [...action.value];  
    default: return state;
  }
}

export default fontadd;
